import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { addDays } from "../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { DrawdownInvestmentStrategyClient } from "../../../../../../Wrap/Api/Account/DrawdownInvestmentStrategy";
import { PersonalDetailClient } from "../../../../../../Wrap/Api/Customer/PersonalDetail";
import { BatchClient } from "../../../../../../Wrap/Api/Orders/Batch";
import { BuySellClient } from "../../../../../../Wrap/Api/Orders/BuySell";
import { OrdersClient } from "../../../../../../Wrap/Api/Orders/Orders";
import { Frequency } from "../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { OrderDirection } from "../../../../../../Wrap/Constants/Enums/Domain/OrderDirection";
import { BatchType } from "../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SellDispatcher } from "../Store/Variable";

export class SellAction {
    public static getClientInfo(customerid: string) {}

    public static initSellModel() {
        const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        const initModel = {
            BatchType: BatchType.OneOff,
            OrderType: BatchType.OneOff,
            ActionDate: JsonDateParser.toJsonDateNoOffset(new Date()),
            HierarchyId: subAccountHierarchyId,
            InvestmentList: [],
            InvestmentPathwayAnswers: { PersonalRecommendation: true}
        };

        SellDispatcher.dispatch({ actionType: ActionType.Success, payload: initModel });
    }

    public static goToNextStep(from, data, callback) {
        if (from == 0) {
            return this.getBatchId(data, callback);
        } else if (from == 1) {
            return this.saveInvestmentSelection(data, callback);
        }
        callback();
    }

    public static saveInvestmentSelection(data, callback) {
        const client = new BuySellClient();
        data.BuyOrSell = OrderDirection.Sell;
        client.post(data).onSuccess((d) => {
            callback(d);
        });
    }

    public static savePensionInvestmentPath(data, callback?) {
        const subaccountid = getQueryParameters()["subaccounthierarchyid"];
        const client = new DrawdownInvestmentStrategyClient();
        let promise = client.post(subaccountid, data.InvestmentPathwayAnswers);
        promise.onSuccess((result) => {
            if(callback) callback(result)
        });
        promise.onError((err) => {
            if(callback) callback(err)
        });
    }

    public static getBatchInfo(data, callback) {
        let promise;
        const client = new BuySellClient();
        data.BuyOrSell = OrderDirection.Sell;
        promise = client.put(data);
        promise.onSuccess((result) => {
            if (callback) {callback(result);}
        });

        promise.onError((err) => {});
    }

    public static getBatchId(data, callback) {
        const batchId = getQueryParameters()["batchId"];
        if (batchId) {
            SellDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) {callback([]);}
            return data;
        }

        let promise;
        const client = new BatchClient();
        promise = client.post(data);
        promise.onSuccess((result) => {
            const payload = {
                ...result,
                OrderType: data.OrderType,
                InvestmentList: data.InvestmentList || [],
                TotalValue: data.TotalValue || [],
                AdviceGiven: true,
                InvestmentPathwayAnswers: { PersonalRecommendation: true }
            };

            SellDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: payload,
            });

            if (callback) { callback(payload); }
        });

        promise.onError((err) => { });
    }

    public static submit(data, callback) {
        const client = new OrdersClient();
        client.post(data).onSuccess((result) => {
            callback(result);
        });
    }

    public static getCustomerName(customerId, callback) {
        const client = new PersonalDetailClient();
        const promise = client.get(customerId).onSuccess((result) => {
            callback(`${result.GivenName} ${result.FamilyName}`);
        });
    }
}
